// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fA","advertDetailContactItem__link":"c-n_fB","advertDetailContactItem__stub":"c-n_fC"};